import classnames from 'classnames'
import PropTypes from 'prop-types'
import { Button } from '../Button/Button'
import { Link } from '../link/Link'
import { Modal, ModalBody, ModalFoot, ModalHead } from '../Modal/Modal'

export const ModalConfirm = ({
  show,
  title,
  message,
  closeOnOverlayClick,
  onClickConfirm,
  onClickCancel,
  showClose,
  stringConfirm,
  stringCancel,
  size,
  variant,
  'data-mu-test': dataAttributeTest,
}) => (
  <Modal
    data-mu-test={classnames('modal--confirm', dataAttributeTest)}
    show={show}
    onClose={onClickCancel}
    showClose={showClose}
    closeOnOverlayClick={closeOnOverlayClick}
    size={size}
  >
    <ModalHead title={title} />
    <ModalBody>
      <p>{message}</p>
    </ModalBody>
    <ModalFoot>
      {variant === 'delete' && (
        <>
          <Link
            className='textlink-extra-light p-right-thin'
            onClick={onClickCancel}
            data-mu-test='link-cancel'
          >
            {stringCancel}
          </Link>
          <Button
            kind={'danger'}
            onClick={onClickConfirm}
            data-mu-test='button-confirm'
          >
            {stringConfirm}
          </Button>
        </>
      )}

      {(variant === 'primary' || !variant) && (
        <>
          <Button
            kind='secondary'
            onClick={onClickCancel}
            data-mu-test='button-cancel'
          >
            {stringCancel}
          </Button>

          <Button
            kind='primary'
            onClick={onClickConfirm}
            data-mu-test='button-confirm'
          >
            {stringConfirm}
          </Button>
        </>
      )}

      {variant === 'danger' && (
        <>
          <Button
            kind='danger'
            onClick={onClickCancel}
            data-mu-test='button-cancel'
          >
            {stringCancel}
          </Button>

          <Button
            kind='primary'
            onClick={onClickConfirm}
            data-mu-test='button-confirm'
          >
            {stringConfirm}
          </Button>
        </>
      )}
    </ModalFoot>
  </Modal>
)

ModalConfirm.propTypes = {
  show: PropTypes.bool,
  title: PropTypes.string,
  message: PropTypes.node,
  onClickConfirm: PropTypes.func,
  onClickCancel: PropTypes.func,
  closeOnOverlayClick: PropTypes.bool,
  showClose: PropTypes.bool,
  stringConfirm: PropTypes.string,
  stringCancel: PropTypes.string,
  size: PropTypes.string,
  variant: PropTypes.oneOf([undefined, 'delete', 'danger', 'primary']),
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string,
}
